import * as z from "zod";

export const deletePoTemplate = {
  name: "deletePoTemplate" as const,
  input: z.object({ templateId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
